import { Navigate, useLocation } from "react-router-dom";

export default function CompensationProfilesRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/career/compensation-profiles to /people/:pgaId/career/compensation
  const newPath = location.pathname.replace("/compensation-profiles", "/compensation");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
